var map = {
	"./dubliner.png": 9616,
	"./freddysbar-half-padding.png": 3198,
	"./freddysbar.png": 4726,
	"./globe.png": 7114,
	"./pubsport-half-padding.png": 1483,
	"./pubsport.png": 5683,
	"./shamrock.png": 3054,
	"./southern-cross.png": 477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9079;